import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import LiveIcon from 'assets/icons/LiveIcon';
import { showInfoModal } from 'components/Modals/CommonModals';
import { CHAT_TAB, ChatTabType } from 'consts/app';
import ChatBox from 'features/chatRoom/components/ChatBox';
import LiveChat from 'features/chatRoom/components/LiveChat';
import { selectEvent, setSearch, setShowEventNoti } from 'features/home/homeSlice';
import useThemes from 'hooks/useThemes';
import { useState } from 'react';
import { FaGift } from 'react-icons/fa';
import { MdEvent } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import CurrentGiveAwayModal from '../Modals/CurrentGiveAwayModal';
import MiniGame from './MiniGame';
import ResultChat from './ResultChat';
import ScoreBoard from 'features/chatRoom/components/ScoreBoard';
import { Tooltip } from 'antd';
import StreamIcon from 'assets/icons/StreamIcon';
interface ChatRoomProps {}

const ChatRoom: React.FC<ChatRoomProps> = ({}) => {
  const eventSelected = useAppSelector(selectEvent);
  const dispatch = useAppDispatch();
  const t = useAppTranslation();
  const [isShowGiveawayModal, setIsShowGiveawayModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const { currentTheme } = useThemes();
  const [activeTab, setActiveTab] = useState<number>(1);

  const handleShowEventNoti = () => {
    if (eventSelected) {
      dispatch(setShowEventNoti(true));
    } else {
      showInfoModal({
        title: t('popup.comingSoon.title'),
        content: t('popup.comingSoon.content'),
      });
    }
  };
  const handleStreamingClick = () => {
    navigate('/streaming');
  };

  const handleChangeChatTab = (tab: ChatTabType) => {
    if (tab.isComingSoon) {
      showInfoModal({
        title: t('popup.comingSoon.title'),
        content: t('popup.comingSoon.content'),
      });
    } else {
      setActiveTab(tab.key);
    }
  };

  const handleLiveGameClick = () => {
    dispatch(
      setSearch({
        searchText: '',
        isSearchLayout: false,
      }),
    );
    navigate('/live-game');
  };

  return (
    <div className="chatroom-container">
      <div className="chat-title">
        {/* <span className={`${isPhone(platform) ? Typo.p7 : isTablet(platform) ? Typo.p5 : Typo.p1}`}>
          {t('chat.public')}
        </span> */}
        <div>
          {CHAT_TAB.map((tab) => (
            <span
              key={tab.key}
              onClick={() => {
                if (activeTab !== tab.key) {
                  handleChangeChatTab(tab);
                }
              }}
              className={`tab_item ${activeTab === tab.key ? 'active-tab' : ''}`}
            >
              {t(tab.labelKey)}
            </span>
          ))}
        </div>
        <div className="chat-bar-tool">
          <div
            className={`minimize-icon cursor-pointer ${
              currentTheme === 'dark' ? 'live-icon' : ''
            } `}
            onClick={handleStreamingClick}
          >
            <StreamIcon className={`w-4 h-4 minimize-icon`} color="black" />
          </div>
          <div
            className={`minimize-icon cursor-pointer ${
              currentTheme === 'dark' ? 'live-icon' : ''
            } `}
            onClick={handleLiveGameClick}
          >
            <LiveIcon className={`w-4 h-4 minimize-icon`} color="black" />
          </div>
          <div className="minimize-icon cursor-pointer " onClick={() => handleShowEventNoti()}>
            <MdEvent />
          </div>
        </div>
      </div>
      <div className="chat-body">
        {activeTab === 1 && <ChatBox />}
        {activeTab === 2 && <LiveChat />}
        {activeTab === 3 && <ResultChat />}
        {activeTab === 4 && <MiniGame />}
        {activeTab === 5 && <ScoreBoard />}
      </div>
      <CurrentGiveAwayModal
        visible={isShowGiveawayModal}
        closeModal={() => setIsShowGiveawayModal(false)}
      />
    </div>
  );
};

export default ChatRoom;
